var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_monitor",
    "data-name": "vuesax/outline/monitor",
    transform: "translate(-428 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    transform: "translate(428 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.067,21.6H6.7c-5.141,0-6.7-1.563-6.7-6.7V6.7C0,1.563,1.563,0,6.7,0h14.35c5.141,0,6.7,1.563,6.7,6.7V14.88C27.771,20.034,26.208,21.6,21.067,21.6ZM6.7,1.937c-4.056,0-4.766.71-4.766,4.766V14.88c0,4.056.71,4.766,4.766,4.766h14.35c4.056,0,4.766-.71,4.766-4.766V6.7c0-4.056-.71-4.766-4.766-4.766Z",
    transform: "translate(1.615 1.615)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.969,4.237C.439,4.237,0,4.007,0,3.731V.506C0,.229.439,0,.969,0s.969.229.969.506V3.731C1.937,4.007,1.5,4.237.969,4.237Z",
    transform: "translate(14.531 23.211)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M22.586,1.937H.816A.909.909,0,0,1,0,.969.909.909,0,0,1,.816,0H22.586A.909.909,0,0,1,23.4.969.909.909,0,0,1,22.586,1.937Z",
    transform: "translate(3.799 15.823)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M12.594,1.937H.969A.976.976,0,0,1,0,.969.976.976,0,0,1,.969,0H12.594a.976.976,0,0,1,.969.969A.976.976,0,0,1,12.594,1.937Z",
    transform: "translate(8.719 27.448)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H31V31H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin2);
export default __webpack_public_path__ + "static/media/spin2.14752490ebec5e9839be1541ed7135d9.svg";
export { ForwardRef as ReactComponent };